<template>
  <section class="services-area ptb-70 bg-f7fafd">
    <div class="container-fluid p-0">
      <div class="overview-box">
        <div class="overview-image">
          <div class="image">
            <img src="assets/img/corporate.jpg" alt="image" />
            
          </div>
        </div>
        <div class="overview-content">
          <div class="content">
            <h2>Corporate Payment Solution</h2>
            
            <p>
              This is a custom payment and fund disbursement solution tailored to fit the needs of SMEs and Corporates in order to simplify and improve efficiency in processing payments. This can be scaled either way to accommodate down from micro-contributions up to Government disbursements.</p>
            <ul class="services-list">
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Saves you transaction charges  
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i>Several transactions can be done at once
                </span>
              </li>
              
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>